import React from "react";
import VideoPlayer from "./common/VideoPlayer";

const Wisdom = (props) => {
  return (
    <>
      <div className="headecon_pad">
        <div className="row row_header_flex">
          <div className="col-sm-6">
            <div className="header_content">
              {props.language == "en" ? (
                <h4>
                  Modi Masterclass is a unique trove of{" "}
                  <span className="widyellow">wisdom,</span>{" "}
                  <span className="exper_blue">experience & knowledge</span>{" "}
                  from Prime Minister
                </h4>
              ) : (
                <h4>
                  मोदी मास्टरक्लास प्रधानमंत्री नरेंद्र मोदी के{" "}
                  <span className="widyellow">विवेक,</span>{" "}
                  <span className="exper_blue">अनुभव और ज्ञान</span> का एक
                  अद्वितीय और अनूठा भंडार है
                </h4>
              )}

              <h3>Narendra Modi</h3>
            </div>
          </div>

          <div className="col-sm-6">
            {props.langu && Object.keys(props.langu).length > 0 && (
              <div className="video_play">
                <img src="/assets/images/tv.png" alt="" />
                <div className="videheader_pos">
                  <VideoPlayer
                    className="video_width"
                    onReady={props.handlePlayerReady}
                    id={props.langu.id}
                    keyi={props.langu.id}
                    key={props.langu.id}
                    video_url={props.langu.url}
                    type="long"
                    thumb={props.langu.thumb}
                  />
                  <span
                    className="play_layer play_layer4"
                    onClick={() => {
                      props.playpause(props.langu.id, "long");
                    }}
                    onMouseMove={() => {
                      props.hideplayIcon(props.langu.id, "long");
                    }}
                  >
                    <img
                      src="/assets/images/play2.svg"
                      className={"play_icon playpausebtn_" + props.langu.id}
                      alt=""
                    />
                  </span>
                  <span
                    className="main_play main_play_new"
                    onClick={() => {
                      props.playpause(props.langu.id, "long");
                    }}
                  ></span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Wisdom;
